import { name as root } from '../actionTypes';

export const invoicesRoot = `${root}/invoices`
export const balanceRoot = `${root}/balance`

export const FETCH_INVOICE_REQUEST = `${invoicesRoot}/fetch/request`
export const FETCH_INVOICE_SUCCESS = `${invoicesRoot}/fetch/success`
export const FETCH_INVOICE_FAILURE = `${invoicesRoot}/fetch/failure`

export const FETCH_BALANCE_SUCCESS = `${balanceRoot}/fetch/request`
export const FETCH_BALANCE_REQUEST = `${balanceRoot}/fetch/success`
export const FETCH_BALANCE_FAILURE = `${balanceRoot}/fetch/failure`

// export const FETCH_INVOICE_AVAILABLE_PDF_REQUEST = `${invoicesRoot}/availablepdfs/fetch/request`
// export const FETCH_INVOICE_AVAILABLE_PDF_SUCCESS = `${invoicesRoot}/availablepdfs/fetch/success`
// export const FETCH_INVOICE_AVAILABLE_PDF_FAILURE = `${invoicesRoot}/availablepdfs/fetch/failure`

export const FETCH_INVOICE_PDF_REQUEST = `${invoicesRoot}/invoicePdf/fetch/request`
export const FETCH_INVOICE_PDF_SUCCESS = `${invoicesRoot}/invoicePdf/fetch/success`
export const FETCH_INVOICE_PDF_FAILURE = `${invoicesRoot}/invoicePdf/fetch/failure`
